<template>
  <v-card>
    <v-form @submit.prevent="submitEditApprovedBillLine()" ref="editApprovedBillLineForm">
      <v-container>
        <v-layout row wrap>
          <dialog-header
            :title="'Edit'"
            :details="`Approved Bill Line (${approvedBillLine.id})`"
            :time="editedApprovedBillLine.updatedAt"
          ></dialog-header>
          <flex-sub-header>Approved Bill Line Details</flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field
              label="Approved Amount"
              v-model="editedApprovedBillLine.amount"
              prepend-icon="money"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Reference No."
              v-model="editedApprovedBillLine.customerClaimRef"
              prepend-icon="insert_drive_file"
              type="text"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Quantity"
              v-model="editedApprovedBillLine.qty"
              prepend-icon="insert_drive_file"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Rate"
              v-model="editedApprovedBillLine.rate"
              prepend-icon="insert_drive_file"
              type="number"
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              rows="1"
              auto-grow
              :rules="internalNotesRules"
              label="Internal Notes"
              v-model="editedApprovedBillLine.internalNotes"
              prepend-icon="note"
              type="text"
            ></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              rows="1"
              auto-grow
              :rules="invoiceNotesRules"
              label="Invoice Notes"
              v-model="editedApprovedBillLine.invoiceNotes"
              prepend-icon="note"
              type="text"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div>
          <v-btn color="grey darken-2" flat @click="discard()">Discard?</v-btn>
          <v-btn color="green" flat type="submit" :loading="loading">Save</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ApprovedBillLineService from '@/services/requests/billService'

// MIXINS
import ApprovedBillLineValidation from '@/services/validation/billValidation'
import FormatDates from '@/services/mixins/formatDates'

// COMPONENTS
import DialogHeader from '@/components/ui/dialogHeader'
import DatePickerWrapper from '@/components/ui/datePickerWrapper'

export default {
  mixins: [ApprovedBillLineValidation, FormatDates],
  components: {
    DialogHeader,
    DatePickerWrapper
  },
  props: {
    approvedBillLine: Object
  },
  data() {
    return {
      editedApprovedBillLine: Object.assign({}, this.approvedBillLine),
      loading: false
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.approvedBillLine, this.editedApprovedBillLine)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    discard() {
      Object.assign({}, this.approvedBillLine)
      this.close()
    },
    submitEditApprovedBillLine() {
      if (!this.$refs.editApprovedBillLineForm.validate()) {
        this.snack({ text: 'Please correct form errors', color: 'red' })
        return
      }
      this.save()
    },
    async save() {
      this.loading = true
      try {
        const payload = {
          amount: this.editedApprovedBillLine.amount
        }
        const result = await ApprovedBillLineService.updateApprovedBillLine(
          this.editedApprovedBillLine.id,
          payload
        )
        result.data.result.approvedBillLine.updated = true
        this.$store.commit('approvedBillLines/updateArrayStateByValue', {
          prop: 'approvedBillLines',
          value: this.approvedBillLine,
          editedValue: result.data.result.approvedBillLine
        })
        this.editedApprovedBillLine = result.data.result.approvedBillLine
        this.snack({ text: 'Approved Bill Line was edited!', color: 'green' })
        this.loading = false
        this.close()
      } catch (err) {
        this.loading = false
        console.log(err)
        this.snackError()
      }
    }
  }
}
</script>
